import { jwtDecode } from 'jwt-decode';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { keyConst } from '@/constants';

interface DecodedToken {
  userId: string;
  companyId?: string;
  userType?: string;
}

const getToken = (): string | null => localStorage.getItem(keyConst.userToken);

export const PrivateRoute = () => {
  const token = getToken();
  const location = useLocation();

  if (!token) {
    return <Navigate to="/auth/signin" state={{ from: location }} replace />;
  }

  let decoded: DecodedToken;
  try {
    decoded = jwtDecode<DecodedToken>(token);
  } catch (e) {
    console.error('Failed to decode token', e);
    return <Navigate to="/auth/signin" replace />;
  }
  const { companyId, userType } = decoded;

  if (userType === 'client' && location.pathname === '/') {
    return <Navigate to="/projects" replace />;
  }
  if (!companyId && userType !== 'client' && location.pathname !== '/select-company') {
    return <Navigate to="/select-company" replace />;
  }
  return <Outlet />;
};
